<!--
 * @info         : 已参赛者轮播条
 * @Creator      : 比诺
 * @CreateDate   : 2021-02-26 18:27:55
 * @LastEditTime : 2021-03-17 18:15:53
-->

<template>
  <div class="participant_carousel_component">
    <van-swipe
      style="height:0.64rem"
      :show-indicators="false"
      :autoplay="2000"
      :touchable="false"
      :height="66"
      vertical
      loop
    >
      <van-swipe-item v-for="(item, index) in dataSource" :key="index">
        <div class="participant_carousel_item">
          <img class="icon" :src="icon" alt="参赛者头像" />
          <p class="info">&nbsp;{{ item.info | limitText(25) }}</p>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import dataSource from './data'
import { Swipe, SwipeItem } from 'vant'

export default {
  name: 'ParticipantCarousel',

  components: {
    vanSwipe: Swipe,
    vanSwipeItem: SwipeItem
  },
  data() {
    return {
      icon: require('paintingCompetition/assets/common/notice.png'),
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.participant_carousel_component {
  display: flex;
  align-items: center;
  .participant_carousel_item {
    box-sizing: border-box;
    height: 48px;
    width: fit-content;
    font-size: 24px;
    color: #fff;
    padding: 0 20px;
    background: rgba(1, 19, 110, 0.4);
    border-radius: 24px;
    position: relative;
    img.icon {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translate(0, -50%);
      height: 30px;
      border-radius: 30px;
      margin-right: 11px;
    }
    .info {
      line-height: 48px;
      text-align: left;
      margin-left: 60px;
    }
  }
}
</style>
